<template>
	<div>
		<v-text-field
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			type="number"
			:name="param.name"
			clearable
			@input="emitUpdate($event)"
			:readonly="readonly">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-text-field>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false
		}
	},
	methods: {
		emitUpdate (val) {
			let float = parseFloat(val)
			if (Number.isNaN(float)) float = ''
			this.$emit('update:value', float)
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		floatCheck (value) {
			if (!value) return true
			return !Number.isNaN(parseFloat(value)) || 'Nombre uniquement'
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		this.rules.push(this.floatCheck)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/float.vue